import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import Hashids from 'hashids'
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }
  forceNavigate(name: string) {
    //  const hash = require('hashids');

    const hashids = new Hashids('', 3);
    const id = hashids.encode(new Date().getTime());
    this.router.navigate(['/'], { fragment: name, queryParams: { v: id.substring(0,2) } });
    //  this.router.navigate(['/'],[{fragment: name},{refresh: new Date().getTime()}])
  }
}
